export default __webpack_public_path__ + "static/media/02.25db3538.png";